import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import clsx from 'clsx';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { NULL_ADDRESS } from 'shared/constants/constants';
import { RoomStatusEnum, WinnerStatusEnum } from 'shared/constants/shared-enums';
import { useCurrenciesStore } from 'shared/store/currenciesStore';
import { useRoomStore } from 'shared/store/roomStore';
import { getPrizeImage } from 'shared/utils/getPrizeImage';
import { isMocked } from 'shared/utils/isMocked';

import BoxHalf from 'assets/png/box-half.png?format=webp;avif&as=picture';
import BoxEmpty from 'assets/png/boxes/empty-box.png?format=webp;avif&as=picture';

interface RoomPrizeImageProps {
  animationsTriggered: boolean;
}

export const RoomPrizeImage = ({ animationsTriggered }: RoomPrizeImageProps) => {
  const [prizeImage, setPrizeImage] = useState(BoxHalf);
  const { activeRoomId } = useParams();
  const { selectedCurrency } = useCurrenciesStore();

  const { bet, playerB, roomStatus, amIPlayerA, winnerStatus } = useRoomStore();

  // prize image
  useEffect(() => {
    const getBetImage = () => {
      const isWinner = amIPlayerA
        ? [WinnerStatusEnum.WinnerPlayerA, WinnerStatusEnum.TechnicalWinnerA].includes(winnerStatus)
        : [WinnerStatusEnum.WinnerPlayerB, WinnerStatusEnum.TechnicalWinnerB].includes(
            winnerStatus,
          );

      if (roomStatus === RoomStatusEnum.Closed) {
        if (!isWinner) return BoxEmpty;
        if (activeRoomId && playerB.address === NULL_ADDRESS) return BoxHalf;

        return getPrizeImage(bet, selectedCurrency);
      }

      return getPrizeImage(bet, selectedCurrency);
    };

    setPrizeImage(getBetImage());
  }, [roomStatus, winnerStatus, amIPlayerA, activeRoomId, playerB, bet, selectedCurrency]);

  return (
    <div
      className={clsx(
        'z-1 blur-4 z-50 self-center sm:max-w-[280px] hd:max-w-[350px]',
        !isMocked && (animationsTriggered ? 'animate-slide-in-from-bottom' : 'animate-fast-appear'),
      )}
    >
      <OptimizedImage data-testid="room-prize-image" imageData={prizeImage} alt="Reward" />
    </div>
  );
};
